<template src="./scanQR-BigBangBoom.html"></template>
<!-- <template src="./scanQR-socoBeautyStar.html"></template> -->

<script>
import QrcodeVue from 'qrcode.vue';
import SocketIO from 'socket.io-client';
import helpers from '@/mixins/helpers';
import connectionHelper from '@/mixins/connection-helper.js';

const QR_CODE_LIFE_TIME = 10 * 60 * 1000;
// const GET_TOKEN_INTERVAL = 5 * 1000;

const Config = require('~/config/default.env').default;

const socket = SocketIO(`${Config.MS_SOCKET_API_URL}/store`, { transports: ['websocket'] });

export default {
  name: 'home',
  components: {
    QrcodeVue,
    PopupTnc: () => import('./snippets/Popup.vue'),
  },
  mixins: [helpers, connectionHelper],
  data() {
    return {
      quotes: null,
      qrGenTimer: null,
      getTokenTimer: null,
      showTnc: false,
    };
  },
  computed: {
    is_development() {
      return Config.NODE_ENV === 'development';
    },
    QRcode() {
      const QRCodeValue = this.$store.state.QRcode.value || '';
      return QRCodeValue;

      // if (this.is_development) {
      //   return 'https://sociolla.test-app.link?action=login&value=' + QRCodeValue;
      // }

      // return 'https://sociolla.app.link?action=login&value=' + QRCodeValue;
    },
    nextUrl() {
      return '/laka-vending-machine-event/bbb-landing';
    },
    beautyATMData() {
      return this.$store.state.beautyAtmData || null;
    },
  },
  async created() {
    Cookies.set('token', '', { expires: 0 });

    const isFromVmCola = this.$route.query && this.$route.query.vmcola === 'true';
    await this.$store.dispatch('getBeautyAtmData', {
      isFromVendingMachine: !isFromVmCola,
      isFromVmCola,
    });
    let is_active_in_offline_store = true;

    if (this.beautyATMData && 'is_active_in_offline_store' in this.beautyATMData) {
      is_active_in_offline_store = Boolean(this.beautyATMData.is_active_in_offline_store);

      if (!is_active_in_offline_store) {
        return;
      }
    }

    this.$store.dispatch('generateQrCode');
    socket.emit('join', this.$store.state.QRcode.value);

    // re-generate qr code every 10 minutes
    this.qrGenTimer = setInterval(() => {
      if (this.$store.state.QRcode.isLoggedIn) {
        // stop re-generation after logging in
        return clearInterval(this.qrGenTimer);
      }
      this.$store.dispatch('generateQrCode');
      socket.emit('join', this.$store.state.QRcode.value);
    }, QR_CODE_LIFE_TIME);

    const self = this;

    socket.on('qr_code_login', function (data) {
      if (self.$store.state.QRcode.value == data.qr_code) {
        Cookies.set('token', data.token, { expires: 1 });
        self.$store.commit('authToken', data.token);
        self.$store.dispatch('getToken', { redirect: self.nextUrl, data: self, is_soco_vending_machine_event: true });
        socket.off('qr_code_login');
      }
    });
    this.initOfflineListener({
      pathOffline: 'offline',
      context: this,
    });
  },

  destroyed() {
    clearInterval(this.qrGenTimer);
    socket.off('qr_code_login');
    this.destroyListener();
  },
};
</script>

<style lang="scss" scoped>
@import 'scanQR';
.bbb-qr {
  background: #000 url('/static/img/laka-event/laka-event-bg.png') no-repeat center center;
  background-size: cover;
  min-height: calc(100vh);
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border;
  padding: 0;
  text-align: center;
}
.title {
  margin: 0 auto 100px;
  display: block;
}
.scanqr-logo {
  position: relative;
  top: -230px;
}
.teaser {
  margin: 0 auto 24px;
  display: block;
}
.scan-qr-machines {
  width: 312px;
  height: 424px;
  background: #fff;
  box-shadow: 3px 12px 12px rgba(48, 0, 10, 0.5);
  border-radius: 7px;
  margin: 0 auto 55px;
  font: normal 30px/42px 'Pretendard', sans-serif;
  letter-spacing: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.scan-qr-machines img {
  margin: 0 auto;
}
.scan-qr-machines img.arrow {
  position: relative;
  top: -3px;
}
.back {
  font: normal 36px 'Pretendard', sans-serif;
  font-family: 'Pretendard', sans-serif;
  color: black;
  margin: 24px 0 0;
  font-weight: 500;
  border-bottom: solid 2px black;
}
.scan-wait {
  font: normal 25px/35px 'Pretendard', sans-serif;
  color: #b32656;
  letter-spacing: 2.5px;
  padding: 24px 0 0;
}
.bbb-wrapper {
  margin-top: -580px;
}
.scan-footers {
  padding: 55px 0;
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
}
.scan-footers p {
  font-family: 'Pretendard', sans-serif;
  font-size: 36px;
  color: #fff;
  text-align: center;
  margin-bottom: 0;
  text-transform: uppercase;
  letter-spacing: 2px;
}

@media screen and (max-width: 950px) and (min-width: 900px) {
  .scan-qr-machines {
    width: 294px;
    height: 373px;
    margin: 0 auto 30px;
    font-size: 26px;
    line-height: 36px;
    letter-spacing: 2.6px;
    padding-top: 10px;
  }

  .back {
    font-size: 31px;
    margin: 20px 0 0;
  }

  .scan-wait {
    font-size: 21px;
    line-height: 30px;
    letter-spacing: 2.2px;
    padding: 20px 0 0;
  }

  .scan-footers {
    transform: scale(0.86);
    left: -64px;
    bottom: -20px;
  }

  .scan-footers p {
    font-size: 31px;
    letter-spacing: 1.7px;
  }
}
</style>
